require("angular")
app = angular.module("workflow.app")

app.directive("mappingGenerator", require("./MappingGenerator"))
